import { ShipmentInvoiceStatusEnum } from "@/types";

export const shipmentInvoiceStatusMachine: Record<ShipmentInvoiceStatusEnum, (keyof typeof ShipmentInvoiceStatusEnum)[]> = {
  created: ['created', 'pending', 'request_review', 'paid', 'cancelled'],
  pending: ['pending', 'request_review', 'paid', 'cancelled'],
  request_review: ['pending', 'request_review', 'paid', 'cancelled'],
  paid: ['paid', 'cancelled'],
  cancelled: ['cancelled'],
}
